import { useState, useContext } from "react";
import {
  IonContent,
  IonPage,
  useIonRouter,
  IonItem,
  IonInput,
  IonLabel,
} from "@ionic/react";
import { UserContext } from "../Context";

const Tab1: React.FC = () => {
  const router = useIonRouter();
  const [isVisible, setIsVisible] = useState<any>(false);
  const { name, setName } = useContext(UserContext);

  const simpleNavigate = () => {
    router.push("/2", "forward", "push");
  };

  return (
    <IonPage>
      <div
        style={{ height: "100%", backgroundColor: "white" }}
        className="flex flex-col  items-center"
      >
        <h2
          className="heading1"
          style={{
            fontSize: "24px",
            paddingTop: "120px",
            fontFamily: "'poppins', sans serif",
          }}
        >
          Qual è il tuo nome?
        </h2>

        <input
          onChange={(e) => setName(e.target.value)}
          className=" text-center"
          style={{
            fontSize: "40px",
            fontFamily: "'poppins', sans serif",
            backgroundColor: "white",
            border: "none",
            color: "#19204D",
            outline: "none",
            marginTop: "150px",
          }}
          onFocus={() => setIsVisible(true)}
          placeholder="Nome"
        />
        {!isVisible && (
          <p style={{ fontWeight: "300" }} className="bsmall">
            TOCCA PER SCRIVERE
          </p>
        )}
        {isVisible && (
          <button
            onClick={() => simpleNavigate()}
            style={{ marginTop: "32px" }}
            className="mainBtn"
          >
            Prosegui
          </button>
        )}
      </div>
    </IonPage>
  );
};

export default Tab1;
